import React from 'react'
import DataDictionary from '../../../components/DataDictionary'

export default () => (
  <section>
    <div className='data-dictionary-header'>
      <h2 className='container'>Data Dictionary</h2>
    </div>
    <DataDictionary/>
  </section>
)
